module.exports = __webpack_public_path__ + "static/media/vertical-rotate.4c7a4b6f.svg";